class AppSettings {
  constructor (sdk) {
    // default
    this.config = { MilitaryTimeWidget: '1' }

    sdk.get(this, 'appsettings', {}, response => {
      this.config = response
    }, '')
  }

  get (configName) {
    return this.config[configName]
  }
}

export default AppSettings



// WEBPACK FOOTER //
// ./src/modules/gateway-sdk/app-settings.js